import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaRestritaSharedModule } from '../../shared/area-restitra.shared.module';
import { FPCConsultaFracaoPatrimonialPdf } from '../../shared/services/documentos-pdf-imprimir/Plano/fpc/fpc-consulta-fracao-patrimonial-pdf';
import { FPCReservaPreviPdf } from '../../shared/services/documentos-pdf-imprimir/Plano/fpc/fpc-reserva-previ-pdf';
import { FpcConsultaFracaoPatrimonialComponent } from './fpc-consulta-fracao-patrimonial/fpc-consulta-fracao-patrimonial.component';
import { FpcExtratoPreviComponent } from './fpc-extrato-previ/fpc-extrato-previ.component';
import { FpcRoutingModule } from './router/fpc.router';
import { FpcService } from './service/fpc.service';


@NgModule({
    imports: [
        CommonModule,
        AreaRestritaSharedModule,
        FpcRoutingModule
    ],
    declarations: [
        FpcConsultaFracaoPatrimonialComponent,
        FpcExtratoPreviComponent,
    ],
    providers: [
        FPCConsultaFracaoPatrimonialPdf,
        FPCReservaPreviPdf,
        FpcService
    ]
})
export class FpcModule {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/fpc/fpc.module.ts